import { Preloader } from "./Preloader.js";

export interface StageOptions {
    element: HTMLDivElement;
    width?: number;
    height?: number;
    elementOffsetHeight?: number;
    className?: string;
    layout?: StageLayout;
}

export type StageLayout = "fixed" | "responsive";

export class Stage {

    public readonly element: HTMLDivElement;
    public readonly background: HTMLDivElement;
    public readonly content: HTMLDivElement;
    public readonly foreground: HTMLDivElement;
    public readonly overlay: HTMLDivElement;
    public readonly cover: HTMLDivElement;
    public readonly preloader: Preloader;

    private _width: number;
    private _height: number;
    private _elementOffsetHeight: number;

    constructor(options: StageOptions) {

        options = e5.object.merge({
            width: 1920,
            height: 1080,
            elementOffsetHeight: 0,
            layout: "fixed"
        } as StageOptions, options);

        this.element = options.element;
        this._width = options.width;
        this._height = options.height;
        this._elementOffsetHeight = options.elementOffsetHeight;

        this.element.classList.add("stage");
        this.element.classList.add("stage--layout-" + options.layout);
        this.element.classList.add("base--gradient");

        if (options.className) {
            this.element.classList.add(options.className);
        }

        this.element.innerHTML = `
        <div class="stage__layer stage__layer--background">
            <div class="stage__logo stage__logo--bottom-left e5 icon-74"></div>
            <div class="stage__logo stage__logo--top-right e5 icon-580"></div>
        </div>
        <div class="stage__layer stage__layer--content"></div>
        <div class="stage__layer stage__layer--foreground"></div>
        <div class="stage__layer stage__layer--overlay"></div>
        <div class="stage__layer stage__layer--cover"></div>
        `;

        this.background = this.element.querySelector(".stage__layer--background");
        this.content = this.element.querySelector(".stage__layer--content");
        this.foreground = this.element.querySelector(".stage__layer--foreground");
        this.overlay = this.element.querySelector(".stage__layer--overlay");
        this.cover = this.element.querySelector(".stage__layer--cover");

        this.preloader = new Preloader({
            container: this.overlay
        });

        if (options.layout === "fixed") {
            this.element.style.width = this._width + "px";
            this.element.style.height = this._height + "px";

            window.addEventListener("resize", () => this.resize());
            this.resize();
        }
    }

    private resize(): void {
        const elements = [this.element];

        const w = window.innerWidth;
        const h = window.innerHeight;
        const upScaling = e5.Url.params.has("upscaling");

        for (let element of elements) {
            const elementWidth = element.offsetWidth;
            const elementHeight = element.offsetHeight + this._elementOffsetHeight;

            let scale = Math.min(w / elementWidth, h / elementHeight);
            if (!upScaling) {
                scale = Math.min(scale, 1);
            }

            if (scale == 1
                && w === elementWidth
                && h === elementHeight) {
                element.style.transform = "initial";
                element.style.top = "0";
                element.style.left = "50%";
                element.style.marginTop = "0";
                element.style.marginLeft = -this._width * 0.5 + "px";
            }
            else {
                const x = (w - elementWidth * scale) * 0.5;
                const y = (h - elementHeight * scale) * 0.5;
                element.style.transformOrigin = "0 0";
                element.style.transform = "translate(" + Math.round(x) + "px, 0) scale(" + scale + ")";
                element.style.top = null;
                element.style.left = null;
                element.style.marginTop = null;
                element.style.marginLeft = null;
            }
        }
    }
}